import { createFileRoute } from '@tanstack/react-router';
import {
  bankAccountProductListScreen,
  productListSearch,
  loadBankAccountProductMessages,
  loadBankAccountProductScreens,
} from '@/modules/bank-account-product/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/cadastro/produtos-conta/')({
  validateSearch: productListSearch,
  staticData: { screen: bankAccountProductListScreen },
  loader: loadBankAccountProductMessages,
  component: lazyScreen(loadBankAccountProductScreens, 'ProductListScreen'),
});
